module.exports = __webpack_public_path__ + "img/VRB.b4b6e1f1.png";